import { Device, from } from '@helpers/media';
import CardGrid from '@stories/Components/CardGrid/CardGrid';
import CardGridStyles, { cardWidth } from '@stories/Components/CardGrid/CardGrid.styles';
import BranchCardStyles from '@stories/Components/Cards/BranchCard/BranchCard.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  overflow: hidden;
`;
const Grid = styled(CardGrid) `
  --maxWidth: 1434px;

  container-type: inline-size;

  ${CardGridStyles.Item} {
    container-type: inline-size;
  }

  @media ${from(Device.TabletSmall)} {
    --rowItems: 2 !important; // Important required to prevent CLS specificity issue
  }

  @media ${from(Device.TabletLarge)} {
    --rowItems: 3 !important;
  }

  @media ${from(Device.Desktop)} {
    --rowItems: 4 !important;
  }

  &:has(${CardGridStyles.Item}) {
    --itemPeek: 60px;

    @media ${from(Device.TabletLarge)} {
      ${BranchCardStyles.Container} {
        ${cardWidth};
      }
    }
  }

  &:not(:has(${CardGridStyles.Item})) {
    ${BranchCardStyles.Container} {
      ${cardWidth};
    }
  }
`;
const BranchCardsStyles = {
    Container,
    Grid,
};
export default BranchCardsStyles;
